import { StyledLocationText } from './LocationText.styles.js';

export const LocationText = ({
  className,
  location,
}: {
  readonly className?: string;
  readonly location: null | string;
}) => {
  return (
    <StyledLocationText
      className={className}
      textStyle="bodyRegular"
    >
      {location ?? 'N/A'}
    </StyledLocationText>
  );
};
